var map = {
	"./particles-autumn.json": "xzjr",
	"./particles-spring.json": "IZGo",
	"./particles-summer.json": "zR3u",
	"./particles-winter.json": "SNq5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Or7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/particles\-.*\.json$
// module id = Or7b
// module chunks = 1